import React, {memo} from "react";
import { Typography, Modal, Box  } from '@mui/material';
import { useNavigate} from 'react-router-dom';


import ButtonMain from "../button/Button_main";
import './Modal_style.scss'

import Logout from '../../assets/logout-large.svg'

const ModalLogout = (props) => {

    const navigate = useNavigate();

    const logout = () => {
        console.log('logout')
        navigate('/')
        localStorage.removeItem("token");
    }

    return(
            <Modal
                open={props.openLogout}
                aria-labelledby="modal-modal-title"
            >
                <div className="modal-container modal-view max-w-25">
                    <div className="modal-text-center">
                        <img src={Logout} alt="trash" className="popup-icon-lg mb-5-modal modal-mt-16"/>
                    </div>
                    <Typography align="center" id="modal-modal-title" className="mb-2-modal" variant="textheader3" component="div">
                        Logout
                    </Typography>
                    <Typography align="center" component={'div'} variant="textBaseLight" className="modal-mb-8">
                        Are you sure you want to logout?
                    </Typography>
                    <div className="modal-footer-center mt-5-modal pt-5-modal border-top-modal">
                        <ButtonMain 
                            variant='primaryOutline' 
                            type='button' 
                            disabled={false} 
                            name='Cancel'
                            class='capitalize'
                            onClick={()=>props.setOpenLogout(false)}
                        />
                        <ButtonMain 
                            variant='red' 
                            type='button' 
                            disabled={false} 
                            name='Logout'
                            class='capitalize'
                            onClick={logout}
                        />
                    </div>
                </div>
            </Modal>
    )
}

export default memo(ModalLogout);